<img class="mx-auto px-[60px]" src="./assets/image.png">